import { apiRequest } from '.';

const API_URL = '/api/profile/resume';

export async function deleteResume() {
  const fetchInit = {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
    },
  };

  const response = await apiRequest(API_URL, fetchInit);
  const json = await response.json();
  return !!json.success;
}

export default deleteResume;
